import React, { PureComponent } from 'react'
import { Card, Input, Button } from 'antd'
import { inject, observer } from 'mobx-react'
import { observable } from 'mobx'
import './style'
import domaninVar from './var.js'

/*
官网首页
*/
@observer
class WebComponent extends PureComponent {

  constructor (props) {
    super(props)
    this.changeValue = this.changeValue.bind(this)
    document.title = domaninVar.company + "官网"
  }

  changeValue (name, e) {
    this.data[name] = e.target.value
  }
  

  render () {
    return (
      <section className='web-css'>
        <div className='ba'>Copyright © 2018 - 2025  {domaninVar.domain} All Rights Reserved {domaninVar.company} 版权所有  |   <a href='https://beian.miit.gov.cn/'>{domaninVar.beian}</a></div>
      </section>
    )
  }
}

export default WebComponent



// WEBPACK FOOTER //
// ./src/containers/web/Index.jsx